export enum Identical {
  Father = "Father",
  Mother = "Mother",
  GrandFather = "GrandFather",
  GrandMother = "GrandMother",
}

export enum IdenticalVariants {
  FatherAndMother = "FatherAndMother",
  FatherAndGrandFather = "FatherAndGrandFather",
  MotherAndGrandMother = "MotherAndGrandMother",
}

export const localizationIdenticalVariants = ["Отец и Мать", "Отец и Дедушка", "Мать и Бабушка"];

export const localizationIdentical: Record<Identical, string> = {
  [Identical.Father]: "Отец",
  [Identical.Mother]: "Мать",
  [Identical.GrandFather]: "Дедушка",
  [Identical.GrandMother]: "Бабушка",
};
